/* POP theme styling controls: keep native product forms and theme section markup. */
(function () {
  'use strict';
  function apply(root) {
    if (!document.documentElement.classList.contains('pop-style-move-cta')) return;
    var scope = root || document;
    scope.querySelectorAll('.product-card.js-product-card').forEach(function (card) {
      if (card.closest('.om-rail .om-card')) return;
      var action = card.querySelector('.js-grid-cart');
      if (!action || action.closest('.pop-style-card-action')) return;
      var info = card.querySelector('.product-card__info');
      if (!info) return;
      var holder = document.createElement('div');
      holder.className = 'pop-style-card-action';
      holder.appendChild(action); // move (not clone), retaining any native event listeners
      info.appendChild(holder);
    });
  }
  function init() { apply(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('pop:cards:updated', function (event) { apply(event.detail && event.detail.root); });
  // Native Ajax search/product grids can be re-rendered after initial page load.
  document.addEventListener('shopify:section:reorder', function (event) { apply(event.target); });
  document.addEventListener('shopify:section:load', function (event) { apply(event.target); });
})();
